import $i18n from '@/i18n';
import { cloneDeep } from 'lodash';
import { Icon } from '@b-design/fusion';
import { formatTime } from '@/utils';
import ColorTags from '@/components/ColorTags';
import { getInvitateStatus } from '@/utils/status.tsx';
import { HasAigcRole, HasOperatorRole } from '@/utils/config';

export const startAcition = {
  INVITE: ['Resend', 'Withdraw'], //"邀请中"
  SUCCESS: [], // "邀请成功"
  EXPIRE: [], //"已过期"
  WITHDRAW: [], //"已撤销"
  USE: [], //"已核销"
};

export const urlEmun = {
  resend: '/rest/intercnn/invitation/resend',
  withdraw: '/rest/intercnn/invitation/revoke',
};

const status = {
  abled: { color: 'var(--superapp-primary-1)', cursor: 'pointer' },
  disabled: { color: 'rgba(212,214,225,1)' },
};

// const statusEmun = {
//   INVITE: 'Invitation Sent',
//   EXPIRE: 'Invitation Expired',
//   WITHDRAW: 'Withdrawn',
//   USE: 'Invitation Success',
// };
const statusEmun = {
  INVITE: $i18n.get({
    id: 'aopf.pages.getInvitateStatus.invitationSent',
    dm: '已发送邀请',
  }),
  EXPIRE: $i18n.get({
    id: 'aopf.pages.getInvitateStatus.invitationExpired',
    dm: '邀请已过期',
  }),
  WITHDRAW: $i18n.get({
    id: 'aopf.pages.getInvitateStatus.withdrawn',
    dm: '已撤回',
  }),
  USE: $i18n.get({
    id: 'aopf.pages.getInvitateStatus.invitationSuccess',
    dm: '邀请成功',
  }),
};

export const renderActionItem = ({ icon, content, abled }) => {
  return (
    <div style={abled ? status.abled : status.disabled}>
      <Icon type={icon} size={'xs'} style={{ marginRight: '12px' }} />
      {content}
    </div>
  );
};

const handleFilters = (values) => {
  const filter = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value, value: key });
  }
  return filter;
};

const roleEmun = Object.assign({}, {
  ADMIN: $i18n.get({
    id: 'aopf.pages.member.actionSetAsAdmin',
    dm: '管理员',
  }),
  DEVELOPER: $i18n.get({
    id: 'aopf.pages.member.actionSetAsDeveloper',
    dm: '开发者',
  }),
}, HasOperatorRole() ? {
  OPERATOR: $i18n.get({
    id: 'aopf.component.invitations.const.OperationsAdministrator',
    dm: '运营管理员',
  }),
} : {}, HasAigcRole() ? {
  AIGC_DESIGNER: $i18n.get({
    id: 'aopf.component.invitations.const.AigcDesigner',
    dm: 'AIGC设计者',
  }),
} : {});

const roleFilters = handleFilters(roleEmun);

const statusFilters = handleFilters(statusEmun);

const renderInvitee = (_v, _i, record) => {
  return (
    <>
      {record?.invitee}
      <br />
      <span style={{ color: 'rgba(146,152,172,1)' }}>{record?.inviteEmail}</span>
    </>
  );
};

export const columns = [
  {
    title: $i18n.get({ id: 'aopf.pages.member.Invitations.columnsInvitations', dm: '邀请' }),
    dataIndex: 'invitee',
    width: 140,
    cell: renderInvitee,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.Invitations.columnsRole', dm: '角色' }),
    dataIndex: 'extInfo.roleList',
    cell: (value, index, record) => {
      const _value = cloneDeep(value || []);

      if (!_value.length) return roleEmun[record?.extInfo?.role] || '';

      if (_value.length === 1) {
        return roleEmun[_value[0]];
      }

      // 管理员 > AIGC设计者 > 开发者
      if (_value.includes('ADMIN') && _value.includes('DEVELOPER')) {
        const index = _value.indexOf('DEVELOPER');
        _value.splice(index, 1);
      }

      if (_value.includes('ADMIN') && _value.includes('OPERATOR')) {
        const index = _value.indexOf('OPERATOR');
        _value.splice(index, 1);
      }

      const sortValue = _value?.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      const _text = sortValue.map((v) => roleEmun[v]);
      return _text.join(' | ');
    },
    width: 160,
    filters: roleFilters,
    filterMode: 'single',
  },
  {
    title: $i18n.get({
      id: 'aopf.pages.member.Invitations.columnsInvitationStatus',
      dm: '邀请状态',
    }),
    dataIndex: 'status',
    width: 200,
    cell: (value) => <ColorTags {...getInvitateStatus(value)} />,
    filters: statusFilters,
    filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.Invitations.columnsSendTime', dm: '发送时间' }),
    dataIndex: 'gmtCreate',
    width: 160,
    cell: (value) => formatTime(value),
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.Invitations.columnsExpirationTime', dm: '过期时间' }),
    dataIndex: 'validDate',
    width: 160,
    cell: (value) => formatTime(value),
  },
];
